export default __webpack_public_path__ + "static/translations-672c89c7dd85ec767fc9b41b13514743.jpg";